import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  {
    namespace,
    elementType,
  }: Boundaries["editSecondaryCriteriaTemplate"]["request"],
): State {
  const index = state.findIndex(
    (req) => req.namespace === namespace && req.type === elementType,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { type: elementType, namespace, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        { type: elementType, namespace, request: setRequestStateToPending() },
      ];
}

function handleSuccess(
  state: State,
  {
    namespace,
    elementType,
  }: Boundaries["editSecondaryCriteriaTemplate"]["success"],
): State {
  const index = state.findIndex(
    (req) => req.namespace === namespace && req.type === elementType,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { type: elementType, namespace, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        { type: elementType, namespace, request: setRequestStateToSuccess() },
      ];
}

function handleFailure(
  state: State,
  {
    namespace,
    elementType,
  }: Boundaries["editSecondaryCriteriaTemplate"]["failure"],
): State {
  const index = state.findIndex(
    (req) => req.namespace === namespace && req.type === elementType,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        { type: elementType, namespace, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        { type: elementType, namespace, request: setRequestStateToFailure() },
      ];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.editSecondaryCriteriaTemplateRequested]: handleRequest,
    [events.editSecondaryCriteriaTemplateSucceeded]: handleSuccess,
    [events.editSecondaryCriteriaTemplateFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
